var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGwsBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 152,
    viewBox: "0 0 149 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_2868)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 132,
    r: 132,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 -148 284)",
    fill: "#C74132",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 108,
    r: 108,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 -124 260)",
    fill: "#C74132",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_2868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 152,
    fill: "white",
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 0 152)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGwsBl);
export default __webpack_public_path__ + "static/media/gws-bl.0aed3a36501998b3eea4ef38b7b71024.svg";
export { ForwardRef as ReactComponent };